"use strict";
/**
 * UK primary year-group taxonomy (EYFS → Y6).
 *
 * YearGroup is used across activities, kits, and reporting to scope content
 * to an age-appropriate cohort. Helpers return age-adaptive labels so that
 * Reception pupils see "Letters & Sounds" while KS1+ sees "Phonics".
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.YEAR_GROUP_ORDER = void 0;
exports.getKeyStage = getKeyStage;
exports.getYearGroupLabel = getYearGroupLabel;
exports.yearGroupIndex = yearGroupIndex;
exports.yearGroupInRange = yearGroupInRange;
exports.getKeyStageFromClassYearGroup = getKeyStageFromClassYearGroup;
exports.YEAR_GROUP_ORDER = [
    'nursery',
    'reception',
    'y1',
    'y2',
    'y3',
    'y4',
    'y5',
    'y6',
];
const YEAR_GROUP_TO_KEY_STAGE = {
    nursery: 'EYFS',
    reception: 'EYFS',
    y1: 'KS1',
    y2: 'KS1',
    y3: 'KS2',
    y4: 'KS2',
    y5: 'KS2',
    y6: 'KS2',
};
const YEAR_GROUP_LABELS = {
    nursery: 'Nursery',
    reception: 'Reception',
    y1: 'Year 1',
    y2: 'Year 2',
    y3: 'Year 3',
    y4: 'Year 4',
    y5: 'Year 5',
    y6: 'Year 6',
};
function getKeyStage(yearGroup) {
    return YEAR_GROUP_TO_KEY_STAGE[yearGroup];
}
function getYearGroupLabel(yearGroup) {
    return YEAR_GROUP_LABELS[yearGroup];
}
/** Index used for range comparisons (nursery = 0 ... y6 = 7). */
function yearGroupIndex(yearGroup) {
    return exports.YEAR_GROUP_ORDER.indexOf(yearGroup);
}
function yearGroupInRange(yearGroup, range) {
    const i = yearGroupIndex(yearGroup);
    return i >= yearGroupIndex(range.min) && i <= yearGroupIndex(range.max);
}
/**
 * Resolves the key stage for a classroom's year group.
 * Same as getKeyStage but named explicitly for the classroom context
 * to make call sites self-documenting.
 */
function getKeyStageFromClassYearGroup(yearGroup) {
    const stage = YEAR_GROUP_TO_KEY_STAGE[yearGroup];
    if (!stage) {
        throw new Error(`Invalid year group: ${yearGroup}`);
    }
    return stage;
}
